



function Empty() {

    return (
        <div id="Empty_page">
            <div className="no-data-wrapper">
                <img src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png" alt="No Data" />
                <div className="no-data-title">لا توجد بيانات</div>
            </div>
        </div>
    );
}

export default Empty;
